import { render, staticRenderFns } from "./Evolutionfleet.vue?vue&type=template&id=25f5940e"
import script from "./Evolutionfleet.vue?vue&type=script&lang=js"
export * from "./Evolutionfleet.vue?vue&type=script&lang=js"
import style0 from "./Evolutionfleet.vue?vue&type=style&index=0&id=25f5940e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports